import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Blog() {
  const { t, localize } = useLanguage();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.posts().then(setPosts).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page" className="bg-white">
      <section className="relative overflow-hidden border-b border-navy/10 bg-surface pb-16 pt-28">
        <span aria-hidden className="text-ghost pointer-events-none absolute -bottom-8 end-0 select-none font-display text-[14vw] italic leading-none">
          Insights
        </span>
        <div className="relative mx-auto max-w-7xl px-6">
          <Reveal><p className="label-luxe text-gold-dark">{t.blog.kicker}</p></Reveal>
          <Reveal delay={1}>
            <h1 className="mt-5 font-display text-5xl font-light tracking-tight text-navy sm:text-6xl">{t.blog.title}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-5 max-w-lg text-sm font-light text-navy/50">{t.blog.sub}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20">
        {loading ? (
          <p data-testid="blog-loading" className="py-16 text-center text-sm text-navy/40">{t.common.loading}</p>
        ) : (
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((post, i) => {
              const loc = localize(post.i18n);
              return (
                <Reveal key={post.slug} delay={i}>
                  <Link
                    to={`/blog/${post.slug}`}
                    data-testid={`blog-card-${post.slug}`}
                    className="group card-lift block border border-navy/10 bg-white"
                  >
                    <div className="img-zoom-frame aspect-[16/10] border-b border-navy/10">
                      <img src={post.image} alt={loc.title} className="h-full w-full object-cover" loading="lazy" />
                    </div>
                    <div className="p-8">
                      <p className="label-luxe text-sage-dark">
                        {post.date} · 4 {t.blog.min}
                      </p>
                      <h2 className="mt-4 font-display text-2xl font-medium leading-snug text-navy transition-colors group-hover:text-gold-dark">
                        {loc.title}
                      </h2>
                      <p className="mt-3 text-xs font-light leading-relaxed text-navy/50">{loc.excerpt}</p>
                      <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy transition-colors group-hover:text-gold-dark">
                        {t.actions.readMore}
                        <ArrowRight size={13} className="transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
